// Turns a tRPC/network failure into something a user can act on.
//
// When a request outlives the edge gateway's limit (or the API is restarting)
// the *gateway* answers the browser with an HTML error page, not JSON. The
// tRPC client still tries to parse it, so `error.message` arrives as
// `Unexpected token '<', "<!DOCTYPE "... is not valid JSON` — which names
// neither the operation nor the cause, and reads like a frontend crash
// (XT-274). Anything of that shape is a gateway/transport failure and is
// reported as one.

const GATEWAY_SIGNATURES = [
  'unexpected token',
  'is not valid json',
  '<!doctype',
  'unexpected end of json input',
  'failed to fetch',
  'networkerror',
  'load failed',
];

export const isGatewayFailure = (message: string): boolean => {
  const normalized = message.toLowerCase();
  return GATEWAY_SIGNATURES.some((sig) => normalized.includes(sig));
};

export const apiErrorMessage = (
  error: { message?: string } | null | undefined,
  fallback: string
): string => {
  const message = error?.message?.trim();
  if (!message) return fallback;
  return isGatewayFailure(message) ? fallback : message;
};
